import Axios from 'axios';
import Instance from '../instance';
import WixConfig from '../../config/wix';

/**
 * -------------------------------------
 * DELETE API request.
 * -------------------------------------
 * 
 * @param path
 * 
 */

const DeleteRequest = (path: string) => {

    /**
    *--------------------------------------------------------------------------
    * Generating URL
    *--------------------------------------------------------------------------
    * URL = Base URL + Path
    *--------------------------------------------------------------------------
    *
    */

    let baseUrl = WixConfig.backendApiBaseUrl;
    let url = baseUrl + path;

    /**
    *--------------------------------------------------------------------------
    * Get instance
    *--------------------------------------------------------------------------
    * Assumed that instance is appended in query param by Wix.
    *--------------------------------------------------------------------------
    * 
    */

    let instance = Instance.get();

    /**
    *--------------------------------------------------------------------------
    * Preparing headers
    *--------------------------------------------------------------------------
    * 
    */

    let headers = {
        accept: 'application/json',
        'Authorization': instance,
        'Content-Type': 'application/json'
    };

    /**
    *--------------------------------------------------------------------------
    * Send request
    *--------------------------------------------------------------------------
    * Send a DELETE request and return a promise that will resolve to JSON
    * response (error or success).
    *--------------------------------------------------------------------------
    * 
    */

    return new Promise((resolve, reject) => {
        Axios.delete(
            url,
            { headers: headers }
        )
            .then((responseJSON) => resolve(responseJSON.data))
            .catch((error) => reject(error.response?.data))
    });

}

export default DeleteRequest;